module.exports = __webpack_public_path__ + "img/keyboard.f2f34b39.svg";